export default {
    quotes (state) {
      return state.quotes
    },

    selectedQuote (state) {
        return state.selectedQuote
    },

    getQuote: state => (quoteId) => {
      return state.quotes().find(quote => quote.quoteId === quoteId)
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/quotes/getters.js